<template>
    <div>
        <TheHeader class="pc-header" />
        <template>
            <BaseTitle 
                :infor="json" 
            />

            <div class="method-resources">
                <BaseTitleCenter 
                    class="method-resources-title" 
                    :title="json.session.title" 
                />
                <p 
                    class="method-resources-text" 
                    v-html="json.session.text"
                ></p>
                <img
                    class="method-resources-image" 
                    :src="json.session.image"
                >
            </div>

            <div class="method-list">
                <BaseTitleCenter 
                    class="method-resources-title" 
                    :title="json.principle.title" 
                /> 
                <dl 
                    class="method-list-dl" 
                    v-for="v in json.principle.list" 
                    :key="v.id"
                >
                    <dt class="method-list-dt"><span class="method-list-dt-span"><b class="method-list-order">{{v.id}}</b>. {{v.title}}</span></dt>
                    <dd class="method-list-dd">{{v.text}}</dd>
                </dl>
            </div>

            <div class="method-process">
                <BaseTitleCenter 
                    class="method-process-title" 
                    :title="json.process.title" 
                />
                <div class="method-process-image" :style="{backgroundImage: 'url(' + json.process.image + ')'}">
                    <span class="L">洞察+分析</span>
                    <span class="R">探索+创意</span>
                    <span class="L">评估+实施</span>
                    <span class="R">原型+方案 </span>
                </div>
            </div>

        </template>
        <TheFooter class="pc-the-footer-other" />
    </div>
</template>
<script>

    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_pc-header.less'
    import '@/assets/less/module/module-the-footer-other_pc-the-footer-other.less'

    import BaseTitle from '@/components/module/BaseTitle'
    import BaseTitleCenter from '@/components/module/BaseTitleCenter'

    export default {
        name: 'PCMethod',
        props: {
            json: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseTitleCenter
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.method-resources {
    text-align: center;
    .method-resources-title {
        padding: 0 0 50px;
    }
    .method-resources-text {
        width: 75.5%;
        max-width: 906px;
        margin: 0 auto 118px;
        font-size: 20px;
        line-height: 1.5em;
        text-align: center;
        color: #666;
    }
    .method-resources-image {
        display: inline-block;
        width: 56.6%;
        max-width: 680px;
        margin-bottom: 118px;
    }
}

.method-list {
    padding-top: 100px;
    padding-bottom: 30px;
    background: #F0F4F6;
    font-size: 20px;
    color: #666;
    text-align: center;
    .method-resources-title {
        padding-bottom: 40px;
    }
    .method-list-dl {
        .method-list-dt {
            position: relative;
            display: inline-block;
            padding: 0 5px 5px;
            margin-bottom: 20px;
            &:after {
                content: '';
                display: block;
                position: absolute;
                bottom: 0;
                left: 0;
                height: 14px;
                width: 100%;
                background: #FF764E;
            }
            .method-list-dt-span {
                position: relative;
                z-index: 10;
                font-weight: bold;
                color: #333;
                .method-list-order {
                    font-size: 30px;
                    color: #333;
                }
            }
        }
        .method-list-dd {
            margin-bottom: 70px;
        }
    }
}

.method-process {
    padding: 100px 0 45px;
    .method-process-image {
        width: 500px;
        height: 500px;
        margin: 80px auto;
        background-size: 100% 100%;
        span {
            display: block;
            width: 240px;
            height: 240px;
            margin-bottom: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 28px;
            // font-weight: bold;
        }
    }
}


</style>
